import { personIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadPerson } from "../people/loaders.ts";
import { peopleTabsFor } from "../people/permissions.ts";
import { PersonPage } from "../people/person-page.tsx";
import { RecordPending } from "../shell/record-pending.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { personSearch, personTabSchema } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/people/$id/{-$tab}");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, tab } = route.useParams();
  const { when } = route.useSearch();
  return viewer === null || peopleTabsFor(viewer).length === 0 ? (
    <NoAccessPage />
  ) : (
    <PersonPage viewer={viewer} personId={id} tab={tab ?? "profile"} when={when ?? "upcoming"} />
  );
};

export const Route = createFileRoute("/_app/people/$id/{-$tab}")({
  params: {
    parse: ({ id, tab }) => ({
      id: parameterOrNotFound(personIdSchema, id),
      tab: parameterOrNotFound(personTabSchema.exclude(["profile"]).optional(), tab),
    }),
    stringify: ({ id, tab }) => ({ id, tab }),
  },
  validateSearch: personSearch,
  loader: async ({ context, params }) => loadPerson(context.data, params.id),
  pendingComponent: () => <RecordPending lead="circle" hasTabs />,
  component: Page,
});
